import {
  Avatar,
  Box,
  Card,
  Grid2 as Grid,
  Stack,
  Typography,
} from "@mui/material";
import UpcomingActivities from "./components/UpcomingActivities";
import OpenWorksCard from "./components/OpenWorksCard";
// import MyOpportunitesCard from "./components/MyOpportunitesCard";
import SecureVolumeCard from "./components/SecureVolumeCard";
import TodaysActivities from "./components/TodaysActivities";
/* import TodaysActivities from "./components/_TodaysActivities";
 */ import { useSelector } from "react-redux";
import { selectUserNo } from "../../store/slices/authSlice";
import { useGetSalesEmployeesQuery } from "../../store/services/customerService";
import PriorityActivities from "./components/PriorityActivities";

const DashboardLayout = () => {
  const currentDate = new Date().toLocaleDateString("sv-SE", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const userNo = useSelector(selectUserNo);
  const { data: employees = [] } = useGetSalesEmployeesQuery();
  const user = employees.find(
    (employee) => userNo && employee.ExternalUserNo === +userNo
  );
  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      {/* Header Section */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: { xs: 2, sm: 3, md: 4 } }}
      >
        <Box>
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: "1.5rem", sm: "1.75rem", md: "2rem" },
              fontWeight: 600,
            }}
            gutterBottom
          >
            Välkommen
          </Typography>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
          >
            {currentDate}
          </Typography>
        </Box>
        <Card
          sx={{
            display: { xs: "none", sm: "flex" },
            alignItems: "center",
            p: 2,
            minWidth: 140,
            boxShadow: 3,
            borderRadius: 3,
            background: "background.paper",
          }}
        >
          <Avatar
            variant="rounded"
            sx={{
              width: { xs: 56, sm: 64 },
              height: { xs: 56, sm: 64 },
              borderRadius: 2,
              boxShadow: 1,
              backgroundColor: "background.default",
              border: "1px solid",
              borderColor: "divider",
              mr: 2,
              flexShrink: 0,
            }}
            src={
              user?.ContactPersonData?.ImageData
                ? `data:image/png;base64,${user.ContactPersonData.ImageData}`
                : undefined
            }
          />
          <Box>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }}
            >
              {user?.ContactPersonData?.Name || "Namn Saknas"}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}
            >
              {user?.ContactPersonData?.Title || "Titel Saknas"}
            </Typography>
            {user?.ContactPersonData?.Email && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: { xs: "0.85rem", sm: "0.95rem" } }}
              >
                {user.ContactPersonData.Email}
              </Typography>
            )}
            {user?.ContactPersonData?.Phone && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: { xs: "0.85rem", sm: "0.95rem" } }}
              >
                {user.ContactPersonData.Phone}
              </Typography>
            )}
          </Box>
        </Card>
      </Stack>
      <Grid container spacing={{ xs: 2, md: 3 }}>
        {/* Quick Stats Row - Responsive card layout */}
        <Grid size={{ xs: 12 }}>
          <Box
            sx={{
              display: { xs: "flex", sm: "grid" },
              gridTemplateColumns: {
                sm: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
              },
              gap: 2,
              overflowX: { xs: "auto", sm: "visible" },
              scrollSnapType: { xs: "x mandatory", sm: "none" },
              pb: { xs: 1, sm: 0 },
              scrollbarWidth: "thin",
              "&::-webkit-scrollbar": { height: 6 },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0, 0, 0, 0.25)",
                borderRadius: 3,
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "rgba(0, 0, 0, 0.05)",
                borderRadius: 3,
              },
            }}
          >
            <Box
              sx={{
                flex: { xs: "0 0 78%" },
                scrollSnapAlign: { xs: "start" },
              }}
            >
              <UpcomingActivities />
            </Box>
            <Box
              sx={{
                flex: { xs: "0 0 78%" },
                scrollSnapAlign: { xs: "start" },
                backgroundColor: "gray",
                borderRadius: 3,
              }}
            >
              <SecureVolumeCard />
            </Box>
            <Box
              sx={{
                flex: { xs: "0 0 78%" },
                scrollSnapAlign: { xs: "start" },
                backgroundColor: "gray",
                borderRadius: 3,
              }}
            >
              <OpenWorksCard />
            </Box>
          </Box>
        </Grid>

        {/* Main Content Area and Sidebar */}
        <Grid
          container
          size={{ xs: 12 }}
          spacing={{ xs: 2, md: 3 }}
          sx={{ mt: { xs: 1, sm: 2 } }}
        >
          {/* Calendar Section - Takes more space on larger screens */}
          <Grid size={{ xs: 12, lg: 8 }}>
            <TodaysActivities />
          </Grid>

          {/* Right Sidebar - Stacks on mobile but retains good layout on all screen sizes */}
          <Grid size={{ xs: 12, lg: 4 }} container spacing={2}>
            {/* Priority Activities */}
            <Grid size={{ xs: 12, sm: 6, lg: 12 }}>
              <PriorityActivities />
            </Grid>

            {/* Coming Activities */}
            {/* <Grid size={{ xs: 12, sm: 6, lg: 12 }}>
              <ComingActivites />
            </Grid> */}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardLayout;
